( function () {
    'use strict';
    /**
    * Licenseplate logics
    * @namespace
    * @property {boolean} isCheckout
    * @property {HtmlElements} selectors
    */
    master.licenseplate = {
        isCheckout: jQuery( '.js-master-checkout' ).length ? true : false,
        selectors: {
            base: '.js-module-licenseplate-lookup',
            info: '.js-module-licenseplate-info'
        },
        /** @function */
        /**
        * Post the licenseplate number to vehicle service and determine the type of licenseplate and if exsists
        * @param {String} jLicense - Licenseplate string value
        * @param {Boolean} reg - Bool to check if reg exsists.
        * @param {Boolean} jLoggedIn - Bool to check if user is logged in.
        */
        check: function ( jLicense, reg, jLoggedIn ) {
            if ( jLoggedIn ) {
                master.store.session.set( 'myAlternateLicenseplate', jLicense );
            }
            else {
                master.store.session.unset( 'myAlternateLicenseplate' );
            }
            master.store.session.set( 'myLicenseplate', jLicense );
            var jThis = this;
            jQuery.ajax( {
                url: master.data.serviceCalendar.endpoint,
                type: 'POST',
                data: {
                    'action': master.data.serviceCalendar.actions.getvehicle,
                    'licenseplate': jLicense
                },
            } ).done( function ( data ) {
                var licenseData = data.Data;
                if ( licenseData.Registreringsnummer !== null ) {
                    if ( licenseData.Artkode === 3 ) {
                        jQuery( master.licenseplate.selectors.base ).addClass( 'module-licenseplate-lookup--business' );
                    }
                    master.store.session.set( 'myCar', JSON.stringify( licenseData ) );
                    jQuery.each( licenseData, function ( index, val ) {
                        if ( val !== null ) {
                            jQuery( master.licenseplate.selectors.info ).show().find( master.licenseplate.selectors.info + '-item[data-item="' + index + '"]' ).text( val.toString().toLowerCase() );
                        }
                    } );
                    if ( reg ) {
                        var prettyLicenseplate = jLicense.substring( 0, 2 ) + ' ' + jLicense.substring( 2, 4 ) + ' ' + jLicense.substring( 4, 7 );
                        jQuery( master.licenseplate.selectors.base + '-input' ).val( prettyLicenseplate );
                        master.extranet.myInfo.liveUpdate( 'license', prettyLicenseplate );
                    }
                }
                else {
                    jThis.clear( true );
                }
            } );
        },
        /** @function */
        /**
        * Clear info and add error
        * @param {Boolean} error - Bool to check if error-classes should be added.
        */
        clear: function ( error ) {
            jQuery( master.licenseplate.selectors.info ).hide().find( master.licenseplate.selectors.info + '-item' ).html( '' );
            if ( error ) {
                jQuery( master.licenseplate.selectors.base + '-input' ).addClass( 'error' ).parent().addClass( 'error' );
            }
        },
        /** @function */
        /**
        * Disable licenseplate input if in checkout
        */
        inCheckout: function () {
            if ( !jQuery( '.js-module-licenseplate-lookup-input' ).val() && master.licenseplate.isCheckout ) {
                jQuery( '.js-module-licenseplate-lookup-input' ).prop( 'disabled', false );
                jQuery( master.licenseplate.selectors.info ).hide();
            }
        },
        /** @function */
        /**
        * Set licenseplate info for logged in user
        * @param {String} jLicense - Licenseplate string value
        */
        extranetSetData: function ( jLicense ) {
            jQuery.ajax( {
                url: master.data.serviceCalendar.endpoint,
                type: 'POST',
                data: {
                    'action': master.data.serviceCalendar.actions.getvehicle,
                    'licenseplate': jLicense
                },
            } ).done( function ( data ) {
                var licenseData = data.Data;
                if ( licenseData.Registreringsnummer !== null ) {
                    jQuery.each( licenseData, function ( index, val ) {
                        if ( val !== null ) {
                            jQuery( master.licenseplate.selectors.info ).show().find( master.licenseplate.selectors.info + '-item[data-item="' + index + '"]' ).text( val.toString().toLowerCase() );
                        }
                    } );
                }
            } );
        },
        /** @function */
        /**
        * Update user licenseplate
        */
        updateUserplate: function () {
            jQuery( 'input[name="CustomField.AccessUser_AccessUser_LicensePlate"]' ).val( jQuery( 'input[name="LicensePlate"]' ).val() );
            jQuery( 'input[name="LicensePlate"]' ).on( 'change', function () {
                jQuery( 'input[name="CustomField.AccessUser_AccessUser_LicensePlate"]' ).val( jQuery( this ).val() );
            } );
            if ( master.store.session.myLicenseplate !== null ) {
                jQuery( '.js-user-info-licenseplate-container' ).css( 'display', 'block' ).find( '.js-user-info-license' ).text( master.store.session.myLicenseplate );
            }else{
                jQuery('.js-master-user-info-and-search-mobile-carinfo-no-info').show();
            }
        },
        /** @function */
        /**
        * Initialize and validate license input
        */
        init: function () {
            var jLicenseInput = jQuery( master.licenseplate.selectors.base + '-input' ),
                jLicenseRegex = /[A-Z]{2}[0-9]{5}/i,
                jThis = this,
                jLicenceEvent = jQuery.Event( 'keydown' );
            if ( jQuery( '.js-webshop-advanced-car-info-profile-view' ).length ) {
                var jLicense = jQuery.trim( jQuery( '.js-webshop-advanced-car-info-profile-view' ).find( '.js-license' ).text() ).replace( /\s/g, '' );
                jThis.extranetSetData( jLicense );
            }
            jLicenceEvent.which = 9;
            if ( jLicenseInput.length ) {
                var myLicenseplate = master.store.session.myLicenseplate,
                    myAlternateLicenseplate = master.store.session.myAlternateLicenseplate;
                if ( myAlternateLicenseplate !== null ) {
                    jLicenseInput.val( myAlternateLicenseplate );
                }
                else {
                    if ( myLicenseplate !== null && jLicenseInput.val() === '' ) {
                        jLicenseInput.val( myLicenseplate );
                    }
                }
                jLicenseInput.on( 'keydown keyup change', function ( event ) {
                    if ( event.which === 9 || event.which === 13 || event.type === 'change' || ( event.type === 'keyup' && jQuery( this ).val().replace(/\s/g, '').length === master.settings.licenseplate.length ) ) {
                        var jValue = jQuery( this ).val().replace( /\s/g, '' ),
                            jLoggedIn = jLicenseInput.is( '.js-module-licenseplate-lookup-input--loggedin' );
                        jQuery( this ).removeClass( 'error' ).parent().removeClass( 'error' );
                        jQuery( master.licenseplate.selectors.base ).removeClass( 'module-licenseplate-lookup--business' );
                        if ( jValue ) {
                            jQuery( this ).trigger( 'blur' );
                            if ( jLicenseRegex.test( jValue ) ) {
                                jThis.check( jValue, true, jLoggedIn );
                            }
                            else {
                                jThis.check( jValue, false, jLoggedIn );
                            }
                        }
                    }
                } ).trigger( jLicenceEvent );
            }
            this.inCheckout();
            this.updateUserplate();
        }
    };
}() );
